import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '../../app/app.service';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

declare var $: any;

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.css']
})

export class AuthenticationComponent implements OnInit {
  constructor(private route: ActivatedRoute, private appService: AppService, private router: Router, public auth: AuthService) { }

  async ngOnInit() {
    let code = this.route.snapshot.queryParamMap.get('code');
    let user;
    this.auth.user$.subscribe((profile) => {
      // localStorage.setItem('user', JSON.stringify(profile));
      user = profile;
    });
    if (user && code) {
      localStorage.setItem('auth', '1');
      // localStorage.setItem('user', user);
      this.router.navigateByUrl('/products');
    } else {
      $.notify({
        icon: "pe-7s-bell",
        message: "Something went wrong"
      }, {
        type: 'danger',
        timer: 1000,
        placement: {
          from: 'top',
          align: 'right'
        }
      });
      this.appService.LogOut();
    }
  }
}
